:host {
  display: block;

  --jump-tab-bg-color: var(--gray-ultralight, #f8f8f8);
  --jump-tab-border-color: var(--neutral-grey-disabled, #CBCBCB);

  /* Permette lo scroll orizzontale */
  overflow-x: auto;
  scrollbar-width: none;
  /* Nasconde la scrollbar in Firefox */
}

:host::-webkit-scrollbar {
  display: none;
  /* Nasconde la scrollbar in Chrome, Safari e Edge */
}

.Wrapper {
  display: flex;
  flex-direction: column;

  /* Permette lo scroll orizzontale */
  overflow-x: auto;
  scrollbar-width: none;
  /* Nasconde la scrollbar in Firefox */
}

.Wrapper::-webkit-scrollbar {
  display: none;
  /* Nasconde la scrollbar in Chrome, Safari e Edge */
}

.ContentWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: var(--alignment, flex-start);

  &.ContentWrapper--Items {
    @media (max-width: 768px) {
      justify-content: flex-start;
      overflow-x: auto;

      .fullBorder {
        justify-content: flex-start;
      }
    }
  }
}

.Content {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: fit-content;

  &.fullBorder {
    width: 100%;
    border-bottom: 1px solid var(--jump-tab-border-color);
    justify-content: var(--alignment, flex-start);
  }

  &.fullBorder.inline ::slotted([slot="tab-item"]) {
    margin-bottom: -1px;
  }

  &.rounded {
    border-radius: 50px;
    background-color: var(--jump-tab-bg-color);
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }
}

jump-tab-item {
  display: flex;
  align-items: flex-end;
  overflow: hidden;

  .tab-title {
    display: block;
    white-space: normal;
    text-align: center;
  }
}
